package es.cragma.fichajefacil

import web.navigator.navigator
import kotlin.js.Date

class JsPlatform: Platform {
    private val userAgent = navigator.userAgent
    private val browserList = listOf("Chrome", "Firefox", "Safari", "Edge")

    override val name: String = userAgent.findAnyOf(browserList, ignoreCase = true)
            ?.let { (startIndex) -> userAgent.substring(startIndex).substringBefore(" ") }
            ?: "Unknown"
}

actual fun getPlatform(): Platform = JsPlatform()
actual fun getCurrentTimeMillis(): Long = Date.now().toLong()

actual fun getDeviceBatteryLevel(): Int = 100
actual fun getDeviceModelName(): String = "Web Browser (JS)"
actual fun getDeviceIpAddress(): String = "185.230.125.1"
actual fun getDeviceLanguage(): String = "es"

actual fun getCurrentGpsLocation(onResult: (DeviceLocation?) -> Unit) {
    onResult(null)
}
